/**
 * GENERATED CODE - DO NOT MODIFY
 */
import { ValidationResult, BlobRef } from '@atproto/lexicon'
import { isObj, hasProp } from '../../../../util'
import { lexicons } from '../../../../lexicons'
import { CID } from 'multiformats/cid'
import * as ComAtprotoRepoStrongRef from '../../../com/atproto/repo/strongRef'

export interface Record {
  /** uri of the collectible */
  collectibleUri?: string
  /** cid of the collection */
  collectibleCid: string
  /** The id returned from Sphere that is unique to this payment */
  paymentId: string
  /** uri of the paymentCollection */
  subject: string
  /** cid of the paymentCollection */
  subjectCid: string
  createdAt: string
  updatedAt?: string
  txId: string
  wallet: string
  postSubject?: ComAtprotoRepoStrongRef.Main
  [k: string]: unknown
}

export function isRecord(v: unknown): v is Record {
  return (
    isObj(v) &&
    hasProp(v, '$type') &&
    (v.$type === 'app.bsky.splx.payment#main' ||
      v.$type === 'app.bsky.splx.payment')
  )
}

export function validateRecord(v: unknown): ValidationResult {
  return lexicons.validate('app.bsky.splx.payment#main', v)
}
